import { Trans } from '@lingui/react/macro'
import { useLingui } from '@lingui/react'
import { Locale, locales, setLocale } from '$src/lib/i18n'
import { userHooks } from '$src/lib/trpcHooks'
import { Box, Card, Group, Select, Text } from '@mantine/core'
import { IconWorld } from '@tabler/icons-react'

const languageOptions = (Object.keys(locales) as Locale[]).map((locale) => ({
  value: locale,
  label: locales[locale],
}))

export function LanguageSettings() {
  const { i18n } = useLingui()
  const { data: user } = userHooks.useMe()
  const updateUser = userHooks.useUpdate()

  const handleLanguageChange = (value: string | null) => {
    if (!value || !user) return
    const locale = value as Locale
    setLocale(locale)
    updateUser.mutate({ id: user.id, data: { uiLanguage: locale } })
  }

  return (
    <Card radius="md" withBorder>
      <Group justify="space-between" align="center" wrap="nowrap">
        <Group gap="md" wrap="nowrap">
          <Box
            style={{
              width: 40,
              height: 40,
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'var(--mantine-color-green-0)',
            }}
          >
            <IconWorld size={20} color="var(--mantine-color-green-6)" />
          </Box>
          <Text fw={600}>
            <Trans>App language</Trans>
          </Text>
        </Group>
        <Select
          data={languageOptions}
          value={i18n.locale}
          onChange={handleLanguageChange}
          allowDeselect={false}
          w={130}
        />
      </Group>
    </Card>
  )
}
